import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { AppVersionItem } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  roleIds?: number[]
  options?: Omit<UseQueryOptions<unknown, Error, AppVersionItem[]>, 'queryKey' | 'queryFn'>
}

export const useUserAppVersionListRequest = ({ roleIds, options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, AppVersionItem[]>(
    [Entities.Users, 'appVersions', JSON.stringify(roleIds)],
    async () => {
      const { data } = await api.v1AdminUsersAppVersionsGet(roleIds)
      return data as AppVersionItem[]
    },
    options
  )
}
